<template>
    <svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 2C4 3.5 8.74184 7.13881 12 10C15.4196 13.003 19.5664 16.0362 23 19" stroke="#D44944" stroke-width="3" stroke-linecap="round"/>
        <path d="M21 2C20.067 2.75865 19.2476 3.61938 18.3841 4.49884C15.9516 6.97619 13.2574 9.02791 10.6127 11.1001C7.65845 13.4149 4.5 16 2 19" stroke="#D44944" stroke-width="3" stroke-linecap="round"/>
    </svg>
</template>
